export default __webpack_public_path__ + "static/media/sms.33b35c20.svg";